import {ChipProps } from "@heroui/chip";
import { DBSchema } from 'idb';
import axios from "axios";
import { siteConfig } from "@/config/site";
import { Console } from "console";

export type ProductModel = {
    id              : string,
    object          : string,
    created         : string,
    picture         : string,
    label           : string,
    price           : number,
    userGroup       : number,
    valid           : boolean
};


interface PaginatedResponse<T> {
  data: T[];
  total: number;
  limit: number;
  offset: number;
}

export class Products {

  Products: ProductModel[] = [] as ProductModel[];//| null = null;

  async Load() {
    console.log("Data extraction");   
    const json: PaginatedResponse<ProductModel> = (await axios.get(siteConfig.Backend_URL + 'product?limit=149&offset=0')).data;

    this.Products = json.data
    
    return json.data
  }
}

export interface ProductDB extends DBSchema {
  products: {
    value: ProductModel;
    key: string;
    indexes: { 'by-id': string };
  };
}
